import { Variant } from '../types';
import { MixpanelEventName } from '../events/mixpanel/mixpanel.types';
import { BigQueryEventName } from '../events/bigQuery/bigQuery.types';
import { GrafanaEventName } from '../events/grafana/grafana.types';

type EventAction = 'show' | 'submit' | 'completed' | 'failed' | 'skip' | 'homepage_cta' | 'resend_code';

const defaultBigQueryEvents = {
    show: 'identification.activation.show',
    submit: 'identification.activation.submit',
    completed: 'identification.activation.completed',
    failed: 'identification.activation.failed',
    skip: 'identification.activation.skip',
    homepage_cta: 'identification.activation.homepage_cta',
    resend_code: 'identification.activation.resend_code',
} as const;

const defaultMixpanelEvents = {
    show: 'Identification - Activation - Show',
    submit: 'Identification - Activation - Submit',
    completed: 'Identification - Activation - Completed',
    failed: 'Identification - Activation - Failed',
    skip: 'Identification - Activation - Skip',
    homepage_cta: 'Identification - Activation - Homepage CTA',
    resend_code: 'Identification - Activation - Resend Code',
} as const;

const defaultGrafanaEvents = {
    show: 'identification.%{platform}.activation.show',
    submit: 'identification.%{platform}.activation.submit',
    completed: 'identification.%{platform}.activation.completed',
    failed: 'identification.%{platform}.activation.failed',
    skip: 'identification.%{platform}.activation.skip',
    homepage_cta: 'identification.%{platform}.activation.homepage_cta',
    resend_code: 'identification.%{platform}.activation.resend_code',
} as const;

const BIG_QUERY_EVENT_MAP: Record<Variant, Record<EventAction, BigQueryEventName>> = {
    default: defaultBigQueryEvents,
    go: defaultBigQueryEvents,
    purchase: defaultBigQueryEvents,
    onboarding: defaultBigQueryEvents,
    team: {
        show: 'team_join.show',
        submit: 'team_join.submit',
        completed: 'team_join.completed',
        failed: 'team_join.failed',
        skip: 'team_join.skip',
        homepage_cta: 'team_join.homepage_cta',
        resend_code: 'team_join.resend_code',
    },
};

const MIXPANEL_EVENT_MAP: Record<Variant, Record<EventAction, MixpanelEventName>> = {
    default: defaultMixpanelEvents,
    go: defaultMixpanelEvents,
    purchase: defaultMixpanelEvents,
    onboarding: defaultMixpanelEvents,
    team: {
        show: 'Team Join - Show',
        submit: 'Team Join - Submit',
        completed: 'Team Join - Completed',
        failed: 'Team Join - Failed',
        skip: 'Team Join - Skip',
        homepage_cta: 'Team Join - Homepage Cta',
        resend_code: 'Team Join - Resend Code',
    },
};

const GRAFANA_EVENT_MAP: Record<Variant, Record<EventAction, GrafanaEventName>> = {
    default: defaultGrafanaEvents,
    go: defaultGrafanaEvents,
    purchase: defaultGrafanaEvents,
    onboarding: defaultGrafanaEvents,
    team: {
        show: 'team_join.%{platform}.show',
        submit: 'team_join.%{platform}.submit',
        completed: 'team_join.%{platform}.completed',
        failed: 'team_join.%{platform}.failed',
        skip: 'team_join.%{platform}.skip',
        homepage_cta: 'team_join.%{platform}.homepage_cta',
        resend_code: 'team_join.%{platform}.resend_code',
    },
};

export const getEventName = (variant: Variant, action: EventAction): BigQueryEventName =>
    BIG_QUERY_EVENT_MAP[variant][action];

export const getMixpanelEventName = (variant: Variant, action: EventAction): MixpanelEventName =>
    MIXPANEL_EVENT_MAP[variant][action];

export const getGrafanaEventName = (variant: Variant, action: EventAction): GrafanaEventName =>
    GRAFANA_EVENT_MAP[variant][action];
